import { render, staticRenderFns } from "./CloudShell.vue?vue&type=template&id=b0b6c956&scoped=true&"
import script from "./CloudShell.vue?vue&type=script&lang=js&"
export * from "./CloudShell.vue?vue&type=script&lang=js&"
import style0 from "./CloudShell.vue?vue&type=style&index=0&id=b0b6c956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b6c956",
  null
  
)

export default component.exports